module.exports = __webpack_public_path__ + "img/roll_face_left.ed07ba6a.svg";